import { render } from "./TheSubscriptionDetails.vue?vue&type=template&id=12b150aa"
import script from "./TheSubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__